import http from "./httpService";
import store from "store";

export default {
    pull() {
        return http.get("/options/auto-reply");
    },

    /**
     * @param {object} options
     * @param {boolean} options.enabled
     * @param {string} options.message
     * @param {number} options.lock_time
     * @returns {Promise<object>}
     */
    store(options = {
        enabled: false,
        message: "",
        lock_time: 3600,
    }) {
        return http.post("/options/auto-reply", options);
    }
}
